module.exports = __webpack_public_path__ + "img/map-marker.f9a09f57.svg";